<template>
  <div>
    <div v-if="isRule == true">
      <div class="page_box">
        <div class="itemBox disWarp" style="width: 644px">
          <div class="bgBox">
            <img src="../../assets/imgs/model1.png" alt="" class="itemBg" />
            <div class="itemBoxTitle">总下单用户数量</div>
            <div class="num">{{ statisticsData.customNum | addComma }}</div>
          </div>
          <div class="bgBox">
            <img src="../../assets/imgs/model4.png" alt="" class="itemBg" />
            <div class="itemBoxTitle">总保安数量</div>
            <div class="num">{{ statisticsData.bodyguardNum | addComma }}</div>
          </div>
          <div class="bgBox">
            <img src="../../assets/imgs/model3.png" alt="" class="itemBg" />
            <div class="itemBoxTitle">总岗位次数</div>
            <div class="num">{{ statisticsData.workdNum | addComma }}</div>
          </div>
          <div class="bgBox">
            <img src="../../assets/imgs/model2.png" alt="" class="itemBg" />
            <div class="itemBoxTitle">总发薪金额</div>
            <div class="num">{{ statisticsData.totalMoney | moneyFormat }}</div>
          </div>
        </div>
        <div class="itemBox" style="width: 644px">
          <div class="disBetween">
            <div class="dis">
              <img src="../../assets/imgs/indexIcon.png" alt="" class="icon" />
              <div class="modelTitle">经营概况</div>
            </div>
            <div class="selectDate">
              <div
                :class="['dateItem', item.key == select ? 'active' : '']"
                v-for="(item, index) in selectDate"
                @click="dateSelect(item)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="disWarp" style="margin-top: 24px">
            <div class="overviewItem">
              <div class="overviewTitle">新增用户</div>
              <div class="num" style="margin: 10px 0">
                {{ overviewData.newCustomNum | addComma }}
              </div>
              <div class="dis" style="font-size: 12px; color: #4e5969">
                <div class="yesteday">昨日</div>
                <div>同比</div>
                <div class="rise">{{ overviewData.newCustomYoy }}</div>
                <img src="../../assets/imgs/rise.png" alt="" class="icon1" />
                <div style="margin-left: 7px">环比</div>
                <div class="decline">{{ overviewData.newCustomQoq }}</div>
                <img src="../../assets/imgs/decline.png" alt="" class="icon1" />
              </div>
            </div>
            <div class="overviewItem">
              <div class="overviewTitle">新增保安</div>
              <div class="num" style="margin: 10px 0">
                {{ overviewData.newBodyguardNum | addComma }}
              </div>
              <div class="dis" style="font-size: 12px; color: #4e5969">
                <div class="yesteday">昨日</div>
                <div>同比</div>
                <div class="rise">{{ overviewData.newBodyguardYoy }}</div>
                <img src="../../assets/imgs/rise.png" alt="" class="icon1" />
                <div style="margin-left: 7px">环比</div>
                <div class="decline">{{ overviewData.newBodyguardQoq }}</div>
                <img src="../../assets/imgs/decline.png" alt="" class="icon1" />
              </div>
            </div>
            <div class="overviewItem">
              <div class="overviewTitle">新增任务</div>
              <div class="num" style="margin: 10px 0">
                {{ overviewData.newJobNum | addComma }}
              </div>
              <div class="dis" style="font-size: 12px; color: #4e5969">
                <div class="yesteday">昨日</div>
                <div>同比</div>
                <div class="rise">{{ overviewData.newJobYoy }}</div>
                <img src="../../assets/imgs/rise.png" alt="" class="icon1" />
                <div style="margin-left: 7px">环比</div>
                <div class="decline">{{ overviewData.newJobQoq }}</div>
                <img src="../../assets/imgs/decline.png" alt="" class="icon1" />
              </div>
            </div>
            <div class="overviewItem">
              <div class="overviewTitle">违约</div>
              <div class="num" style="margin: 10px 0">
                {{ overviewData.newViolateNum | addComma }}
              </div>
              <div class="dis" style="font-size: 12px; color: #4e5969">
                <div class="yesteday">昨日</div>
                <div>同比</div>
                <div class="rise">{{ overviewData.newViolateYoy }}</div>
                <img src="../../assets/imgs/rise.png" alt="" class="icon1" />
                <div style="margin-left: 7px">环比</div>
                <div class="decline">{{ overviewData.newViolateQoq }}</div>
                <img src="../../assets/imgs/decline.png" alt="" class="icon1" />
              </div>
            </div>
          </div>
        </div>
        <div class="itemBox1" style="width: 100%">
          <template>
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane label="保安分布图" name="first">
                <div style="margin: 10px 0; display: flex; align-items: center">
                  <el-select
                    v-model="cityCode"
                    filterable
                    placeholder="选择所属省份"
                    style="margin-right: auto; width: 150px"
                    @change="selectCity"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.adcode"
                      v-for="(item, index) in cityList"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="cityCode1"
                    filterable
                    @clear="clearCity"
                    clearable
                    placeholder="选择所属城市"
                    style="margin-right: auto; width: 150px"
                    @change="selectCity1"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.adcode"
                      v-for="(item, index) in city1"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="cityCode2"
                    filterable
                    @clear="clearCity1"
                    clearable
                    placeholder="选择所属地区"
                    style="margin-right: auto; width: 130px"
                    @change="selectCity2"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.adcode"
                      v-for="(item, index) in city2"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="zhengjian"
                    @change="selectCertificate"
                    placeholder="选择证件"
                    clearable
                    @clear="clearZhen"
                    style="margin-right: auto; width: 130px"
                  >
                    <el-option
                      :label="item.title"
                      :value="item.id"
                      v-for="(item, index) in certificate"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="level"
                    placeholder="选择等级"
                    clearable
                    style="margin-right: auto; width: 150px"
                  >
                    <el-option
                      :label="item.propDesc"
                      :value="item.propValue"
                      v-for="(item, index) in ids"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="articleName"
                    maxlength="50"
                    clearable
                    placeholder="请输入姓名"
                    style="width: 130px"
                  ></el-input>
                  <el-input
                    v-model="articlePhone"
                    maxlength="50"
                    clearable
                    placeholder="请输入手机号"
                    style="width: 130px"
                  ></el-input>
                  <el-button
                    type="primary"
                    @click="serch()"
                    class="btn"
                    style="display: inline-block; margin-left: 20px"
                    >查询</el-button
                  >
                  <el-button @click="resetSearch()">重置</el-button>
                  <el-button @click="big()" type="primary" class="btn"
                    >全屏</el-button
                  >
                </div>
                <div style="display: flex">
                  <div style="width: 79%; border-right: 1px solid #ccc">
                    <div
                      v-if="showBaoan"
                      style="
                        display: flex;
                        position: relative;
                        width: 100%;
                        height: 550px;
                      "
                      id="bigPage"
                    >
                      <div class="mapSearch" v-if="isFullscreen">
                        <div
                          class="searchBox"
                          v-if="showDown"
                          style="display: flex; align-items: center"
                        >
                          <el-select
                            :popper-append-to-body="false"
                            v-model="cityCode"
                            filterable
                            placeholder="选择所属省份"
                            style="margin-right: auto; width: 150px"
                            @change="selectCity"
                          >
                            <el-option
                              :label="item.name"
                              :value="item.adcode"
                              v-for="(item, index) in cityList"
                              :key="index"
                            ></el-option>
                          </el-select>
                          <el-select
                            :popper-append-to-body="false"
                            v-model="cityCode1"
                            filterable
                            @clear="clearCity"
                            clearable
                            placeholder="选择所属城市"
                            style="margin-right: auto; width: 150px"
                            @change="selectCity1"
                          >
                            <el-option
                              :label="item.name"
                              :value="item.adcode"
                              v-for="(item, index) in city1"
                              :key="index"
                            ></el-option>
                          </el-select>
                          <el-select
                            :popper-append-to-body="false"
                            v-model="cityCode2"
                            filterable
                            @clear="clearCity1"
                            clearable
                            placeholder="选择所属地区"
                            style="margin-right: auto; width: 130px"
                            @change="selectCity2"
                          >
                            <el-option
                              :label="item.name"
                              :value="item.adcode"
                              v-for="(item, index) in city2"
                              :key="index"
                            ></el-option>
                          </el-select>
                          <el-select
                            :popper-append-to-body="false"
                            v-model="zhengjian"
                            @change="selectCertificate"
                            placeholder="选择证件"
                            clearable
                            @clear="clearZhen"
                            style="margin-right: auto; width: 130px"
                          >
                            <el-option
                              :label="item.title"
                              :value="item.id"
                              v-for="(item, index) in certificate"
                              :key="index"
                            ></el-option>
                          </el-select>
                          <el-select
                            :popper-append-to-body="false"
                            v-model="level"
                            placeholder="选择等级"
                            clearable
                            style="margin-right: auto; width: 150px"
                          >
                            <el-option
                              :label="item.propDesc"
                              :value="item.propValue"
                              v-for="(item, index) in ids"
                              :key="index"
                            ></el-option>
                          </el-select>
                          <el-input
                            v-model="articleName"
                            maxlength="50"
                            clearable
                            placeholder="请输入姓名"
                            style="width: 130px"
                          ></el-input>
                          <el-input
                            v-model="articlePhone"
                            maxlength="50"
                            clearable
                            placeholder="请输入手机号"
                            style="width: 130px"
                          ></el-input>
                          <el-button
                            type="primary"
                            @click="serch()"
                            class="btn"
                            style="display: inline-block; margin-left: 20px"
                            >查询</el-button
                          >
                          <el-button @click="resetSearch()">重置</el-button>
                          <el-button
                            @click="exitFullscreen()"
                            type="primary"
                            class="btn"
                            >退出全屏</el-button
                          >
                        </div>
                        <div style="text-align: right; margin-right: 30px">
                          <img
                            style="width: 40px; height: 25px"
                            src="../../assets/imgs/down.png"
                            alt=""
                            v-if="!showDown"
                            @click="selectShow"
                          />
                          <img
                            style="width: 40px; height: 25px"
                            src="../../assets/imgs/up.png"
                            alt=""
                            v-if="showDown"
                            @click="selectShow"
                          />
                        </div>
                        <div
                          style="
                            position: absolute;
                            right: 0;
                            top: 20vh;
                            width: 21%;
                            display: flex;
                            align-items: center;
                          "
                        >
                          <div
                            v-if="showDown"
                            style="
                              background: #fff;
                              box-sizing: border-box;
                              font-weight: 600;
                            "
                          >
                            <div
                              style="
                                padding: 8px 0;
                                box-sizing: border-box;
                                background: #165dff;
                                color: #fff;
                              "
                            >
                              <div
                                style="
                                  font-size: 16px;
                                  font-weight: 600;
                                  padding-left: 10px;
                                  box-sizing: border-box;
                                "
                              >
                                保安列表
                              </div>
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  padding-left: 10px;
                                  box-sizing: border-box;
                                "
                              >
                                <div>地区：{{ showAddress }}</div>
                                <div style="margin-left: 10px">
                                  人数：{{ baoanTotal }}
                                </div>
                              </div>
                            </div>
                            <div
                              style="height: 440px; overflow-y: scroll"
                              v-if="baoanList.length > 0"
                            >
                              <div
                                class="baoanItem"
                                v-for="(item, index) in baoanList"
                                :key="index"
                                @click="seeItem(item)"
                              >
                                <div
                                  style="text-align: center; margin-right: 6px"
                                >
                                  <img
                                    :src="
                                      item.headimgUrl ||
                                      require('@/assets/imgs/headImg.png')
                                    "
                                    alt=""
                                  />
                                  <a
                                    :href="'/askariDetail?id=' + item.id"
                                    style="
                                      display: block;
                                      width: 50px;
                                      text-decoration: none;
                                      height: 20px;
                                      line-height: 20px;
                                      text-align: center;
                                      color: #fff;
                                      background: #0091ff;
                                      border-radius: 10px;
                                      margin-left: auto;
                                      font-size: 10px;
                                    "
                                    >查看更多</a
                                  >
                                </div>
                                <div>
                                  <div>
                                    {{
                                      item.accountType == 0
                                        ? item.companyName
                                        : item.cardName
                                    }}({{ item.lastLoginCity }}-{{
                                      item.lastLoginArea
                                    }})
                                  </div>
                                  <div style="font-size: 10px; margin: 4px 0">
                                    最近登录时间：{{ item.lastLoginTime }}
                                  </div>
                                  <div style="font-size: 10px">
                                    最近登录地址：{{ item.lastLoginAddress }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <el-pagination
                              style="margin: 20px 0 0"
                              v-if="baoanList.length > 0"
                              layout="prev, pager, next"
                              :total="baoanTotal"
                              @current-change="baoanHandleCurrentChange"
                              small
                            >
                            </el-pagination>
                            <div
                              v-else
                              style="text-align: center; margin: 200px 0"
                            >
                              暂无更多数据
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id="map"
                        style="width: 100%; height: 100%; z-index: 99"
                        v-loading.fullscreen.lock="mapLoading"
                      ></div>
                    </div>
                  </div>
                  <div
                    style="width: 21%; box-sizing: border-box; font-weight: 600"
                  >
                    <div
                      style="
                        padding: 8px 0;
                        box-sizing: border-box;
                        background: #165dff;
                        color: #fff;
                      "
                    >
                      <div
                        style="
                          font-size: 16px;
                          font-weight: 600;
                          padding-left: 10px;
                          box-sizing: border-box;
                        "
                      >
                        保安列表
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          padding-left: 10px;
                          box-sizing: border-box;
                        "
                      >
                        <div>地区：{{ showAddress }}</div>
                        <div style="margin-left: 10px">
                          人数：{{ baoanTotal }}
                        </div>
                      </div>
                    </div>
                    <div
                      style="height: 440px; overflow-y: scroll"
                      v-if="baoanList.length > 0"
                    >
                      <div
                        class="baoanItem"
                        v-for="(item, index) in baoanList"
                        :key="index"
                        @click="seeItem(item)"
                      >
                        <div style="text-align: center; margin-right: 6px">
                          <img
                            :src="
                              item.headimgUrl ||
                              require('@/assets/imgs/headImg.png')
                            "
                            alt=""
                          />
                          <a
                            :href="'/askariDetail?id=' + item.id"
                            style="
                              display: block;
                              width: 50px;
                              text-decoration: none;
                              height: 20px;
                              line-height: 20px;
                              text-align: center;
                              color: #fff;
                              background: #0091ff;
                              border-radius: 10px;
                              margin-left: auto;
                              font-size: 10px;
                            "
                            >查看更多</a
                          >
                        </div>
                        <div>
                          <div>
                            {{
                              item.accountType == 0
                                ? item.companyName
                                : item.cardName
                            }}({{ item.lastLoginCity }}-{{
                              item.lastLoginArea
                            }})
                          </div>
                          <div style="font-size: 10px; margin: 4px 0">
                            最近登录时间：{{ item.lastLoginTime }}
                          </div>
                          <div style="font-size: 10px">
                            最近登录地址：{{ item.lastLoginAddress }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <el-pagination
                      style="margin: 20px 0 0"
                      v-if="baoanList.length > 0"
                      layout="prev, pager, next"
                      :total="baoanTotal"
                      @current-change="baoanHandleCurrentChange"
                      small
                    >
                    </el-pagination>
                    <div v-else style="text-align: center; margin: 200px 0">
                      暂无更多数据
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="用户下单分布图" name="second">
                <div v-if="showUser">
                  <div id="map1" style="width: 100%; height: 500px"></div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="邀请排名" name="third">
                <template>
                  <el-table
                    ref="scrollTable"
                    :data="rankingData"
                    height="302px"
                    border
                  >
                    <el-table-column label="排名">
                      <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="cardName" label="姓名">
                      <template slot-scope="scope">
                        <span>{{
                          scope.row.accountType == 0
                            ? scope.row.companyName
                            : scope.row.cardName
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="num"
                      label="邀请人数(点击可查看邀请人)"
                    >
                      <template slot-scope="scope">
                        <span class="peopleNum" @click="goAskair(scope.row)">{{
                          scope.row.num
                        }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div>
        <div class="itemBox1" style="width: 644px">
          <div class="disBetween bgColor">
            <div class="dis">
              <img src="../../assets/imgs/indexIcon.png" alt="" class="icon" />
              <div class="modelTitle">拦截任务</div>
              <div class="pending">待处理: {{ intercepttotalRows }}</div>
            </div>
            <!-- <div class="more" @click="selectMore(1)">
            <div>查看更多</div>
            <img src="../../assets/imgs/more.png" alt="" />
          </div> -->
          </div>
          <div
            class="dis bgColorTitle"
            v-for="(item, index) in regulationData"
            :key="index"
            v-if="item.type == 0"
          >
            <div class="titleItem dis">
              <div class="titleKey">发布人类型：</div>
              <div class="titleval">
                {{
                  item.publisherType == 0
                    ? "所有"
                    : item.publisherType == 1
                    ? "个人"
                    : "企业"
                }}
              </div>
            </div>
            <div class="titleItem dis">
              <div class="titleKey">地区：</div>
              <div class="titleval">{{ item.cutRule.cityName }}</div>
            </div>
            <div class="titleItem dis">
              <div class="titleKey">总金额：</div>
              <div class="titleval">
                ￥{{ item.cutRule.moneyValue | moneyFormat }}以上
              </div>
            </div>
            <div class="titleItem dis">
              <div class="titleKey">截停时间：</div>
              <div class="titleval">
                {{ item.cutRule.cutTimeValue | maxTime }}
              </div>
            </div>
            <div class="indexBtn dis" @click="goRegulation">
              <img src="../../assets/imgs/setting.png" alt="" />
              <div>设置规则</div>
            </div>
          </div>
          <div class="tableBorder">
            <el-table
              ref="scrollTable"
              :data="interceptData"
              style="width: 100%"
            >
              <el-table-column label="倒计时" width="120" align="center">
                <template slot-scope="scope">
                  <i class="el-icon-time"></i>
                  <span style="margin-left: 10px">{{
                    scope.row.leaveTime | maxTime1
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="任务名称/城市/人数/要求"
                width="300"
                align="center"
              >
                <template slot-scope="scope">
                  <el-popover trigger="hover" placement="top">
                    <p>
                      {{ scope.row.title }}-{{ scope.row.rangeName }}-{{
                        scope.row.readiesNum
                      }}/{{ scope.row.membersNum }}人-{{
                        scope.row.high / 100
                      }}米-¥{{ scope.row.advancePayment }}
                    </p>
                    <div slot="reference" class="name-wrapper">
                      <div class="omit">
                        {{ scope.row.title }}-{{ scope.row.rangeName }}-{{
                          scope.row.readiesNum
                        }}人-{{ scope.row.high / 100 }}米-¥{{
                          scope.row.advancePayment
                        }}
                      </div>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="creatorName"
                label="发布人"
                width="80"
                align="center"
              >
              </el-table-column>
              <el-table-column label="操作" align="center" width="120">
                <template slot-scope="scope">
                  <div class="disAround">
                    <div class="operateBtn" @click="stop(scope.row)">
                      {{ scope.row.realActionAt != null ? "暂停" : "启动" }}
                    </div>
                    <div class="operateBtn" @click="nowSend(scope.row, 3)">
                      立即发布
                    </div>
                    <div class="operateBtn" @click="handleEdit(scope.row, 3)">
                      派单
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="itemBox1" style="width: 644px">
          <div class="disBetween bgColor">
            <div class="dis">
              <img src="../../assets/imgs/indexIcon.png" alt="" class="icon" />
              <div class="modelTitle">违约待处理</div>
              <div class="pending">待处理: {{ waitdispatchlisttotalRows }}</div>
            </div>
            <div class="more" @click="selectMore(2)">
              <div>查看更多</div>
              <img src="../../assets/imgs/more.png" alt="" />
            </div>
          </div>
          <div class="dis bgColorTitle tabelRight">
            <div
              class="indexBtn"
              style="margin-right: 24px"
              @click="goViolation1"
            >
              <img src="../../assets/imgs/setting.png" alt="" />
              <div>查看违约规则</div>
            </div>
            <div class="indexBtn" @click="goRegulation">
              <img src="../../assets/imgs/setting.png" alt="" />
              <div>设置规则</div>
            </div>
          </div>
          <div class="tableBorder">
            <el-table
              ref="scrollTable"
              :data="waitdispatchlistData"
              style="width: 100%"
            >
              <el-table-column
                prop="violateLogNo"
                label="单号"
                align="center"
                width="150"
              >
              </el-table-column>
              <el-table-column label="任务名称" align="center">
                <template slot-scope="scope">
                  <el-popover
                    trigger="hover"
                    placement="top"
                    popper-class="popover"
                  >
                    <p>{{ scope.row.jobTitle }}</p>
                    <div slot="reference" class="name-wrapper">
                      <div class="omit">{{ scope.row.jobTitle }}</div>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="memberName" label="违约人" align="center">
              </el-table-column>
              <el-table-column
                prop="violateAt"
                label="违约时间"
                align="center"
                width="160"
              >
              </el-table-column>
              <el-table-column label="触发规则" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.withholdType == 2">￥</span>
                  <span>{{ scope.row.withholdNum }}</span>
                  <span v-if="scope.row.withholdType == 1">%</span>
                </template>
              </el-table-column>
              <el-table-column label="违约金额" align="center">
                <template slot-scope="scope">
                  <span>￥{{ scope.row.violateAmount | moneyFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column label="违约状态" align="center" width="100">
                <template slot-scope="scope">
                  <span class="yellowColor" v-if="scope.row.status == 0"
                    >待支付</span
                  >
                  <span class="greenColor" v-if="scope.row.status == 1"
                    >已支付</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                fixed="right"
                width="120"
              >
                <template slot-scope="scope">
                  <div class="disAround">
                    <div class="operateBtn" @click="goDetail(scope.row)">
                      查看
                    </div>
                    <div
                      class="operateBtn"
                      @click="handleEdit(scope.row, 4)"
                      v-if="scope.row.memberType != 1"
                    >
                      派单
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="itemBox1" style="width: 100%">
          <div
            class="disBetween bgColor"
            style="
              background: linear-gradient(180deg, #eff5ff 0%, #ffffff 100%);
            "
          >
            <div class="dis">
              <img src="../../assets/imgs/indexIcon.png" alt="" class="icon" />
              <div class="modelTitle">派单列表</div>
              <div class="pending">待处理: {{ dispatchlisttotalRows }}</div>
            </div>
            <div class="tabelRight">
              <div class="titleItem dis">
                <div class="titleKey">显示结束时间：</div>
                <div
                  class="titleval"
                  v-for="(item, index) in regulationData"
                  :key="index"
                  v-if="item.type == 1"
                >
                  {{ item.dispatchRule.dispatchEndTimeValue | maxTime }}
                </div>
              </div>
              <div class="indexBtn" @click="goRegulation">
                <img src="../../assets/imgs/setting.png" alt="" />
                <div>设置规则</div>
              </div>
              <div class="solid"></div>
              <div class="more" @click="selectMore(3)">
                <div>查看更多</div>
                <img src="../../assets/imgs/more.png" alt="" />
              </div>
            </div>
          </div>
          <div class="tableBorder">
            <el-table
              ref="scrollTable"
              :data="dispatchlistData"
              style="width: 100%"
            >
              <el-table-column prop="creatorName" label="客户" align="center">
              </el-table-column>
              <el-table-column prop="title" label="任务名称" align="center">
              </el-table-column>
              <el-table-column prop="area" label="区域" align="center">
              </el-table-column>
              <el-table-column label="要求人数" align="center">
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.readiesNum }}/{{ scope.row.membersNum }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="距离结束时间" align="center">
                <template slot-scope="scope">
                  <span :class="[scope.row.selectTime < 0 ? 'redColor1' : '']"
                    ><span v-if="scope.row.selectTime < 0">-</span
                    ><span v-if="scope.row.day > 0">{{ scope.row.day }}天</span
                    ><span v-if="scope.row.hour1 > 0"
                      >{{ scope.row.hour1 }}小时</span
                    ><span v-if="scope.row.middle > 0"
                      >{{ scope.row.middle }}分</span
                    ><span>{{ scope.row.theTime }}秒</span></span
                  >
                </template>
              </el-table-column>
              <el-table-column label="总金额" align="center">
                <template slot-scope="scope">
                  <span>￥{{ scope.row.price | moneyFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column label="加价" align="center">
                <template slot-scope="scope">
                  <span>￥{{ scope.row.markUp }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                  <div class="disAround">
                    <div class="operateBtn" @click="goDetail1(scope.row)">
                      查看
                    </div>
                    <div class="operateBtn" @click="handleEdit(scope.row, 5)">
                      派单
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="itemBox1" style="width: 100%">
          <div
            class="disBetween bgColor"
            style="
              background: linear-gradient(180deg, #eff5ff 0%, #ffffff 100%);
            "
          >
            <div class="dis">
              <img src="../../assets/imgs/indexIcon.png" alt="" class="icon" />
              <div class="modelTitle">回访超期</div>
              <div class="pending">待处理: {{ followuptotalRows }}</div>
            </div>
            <div class="tabelRight">
              <div class="titleItem dis">
                <div class="titleKey">回访时间要求：</div>
                <div
                  class="titleval"
                  v-for="(item, index) in regulationData"
                  :key="index"
                  v-if="item.type == 2"
                >
                  {{ item.followupRule.followupRequireTimeValue | maxTime }}
                </div>
              </div>
              <div class="indexBtn" @click="goRegulation">
                <img src="../../assets/imgs/setting.png" alt="" />
                <div>设置规则</div>
              </div>
              <div class="solid"></div>
              <div class="more" @click="selectMore(4)">
                <div>查看更多</div>
                <img src="../../assets/imgs/more.png" alt="" />
              </div>
            </div>
          </div>
          <div class="tableBorder">
            <el-table
              ref="scrollTable"
              :data="followupData"
              style="width: 100%"
            >
              <el-table-column prop="customName" label="客户" align="center">
              </el-table-column>
              <el-table-column label="任务名称" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.jobTitle }}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务完成时间" align="center" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.jobCashAt }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="nickname" label="负责人" align="center">
              </el-table-column>
              <el-table-column label="回访超期" align="center" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.wantCallAt }}</span>
                </template>
              </el-table-column>
              <el-table-column label="状态" align="center">
                <template slot-scope="scope">
                  <span class="redColor" v-if="scope.row.status == 0"
                    >未完成</span
                  >
                  <span class="blueColor" v-if="scope.row.status == 1"
                    >回访中</span
                  >
                  <span class="greenColor" v-if="scope.row.status == 2"
                    >已完成</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="180">
                <template slot-scope="scope">
                  <div class="disAround">
                    <div
                      class="operateBtn"
                      @click="stop1(scope.row)"
                      v-if="scope.row.userId == '' || scope.row.userId == null"
                    >
                      分配
                    </div>
                    <div
                      class="operateBtn"
                      @click="stopData(scope.row)"
                      v-if="scope.row.userId != '' && scope.row.userId != null"
                    >
                      取回
                    </div>
                    <div class="operateBtn" @click="goDetail2(scope.row)">
                      查看
                    </div>
                    <div
                      class="operateBtn"
                      @click="set(scope.row)"
                      v-if="scope.row.status != 2"
                    >
                      记录
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="itemBox1" style="width: 100%">
          <div
            class="disBetween bgColor"
            style="
              background: linear-gradient(180deg, #eff5ff 0%, #ffffff 100%);
            "
          >
            <div class="dis">
              <img src="../../assets/imgs/indexIcon.png" alt="" class="icon" />
              <div class="modelTitle">投诉处理</div>
              <div class="pending">待处理: {{ complaintalRows }}</div>
            </div>
            <div class="tabelRight">
              <div class="more" @click="selectMore(5)">
                <div>查看更多</div>
                <img src="../../assets/imgs/more.png" alt="" />
              </div>
            </div>
          </div>
          <div class="tableBorder">
            <el-table
              ref="scrollTable"
              :data="complainData"
              style="width: 100%"
            >
              <el-table-column prop="id" label="单号" align="center">
              </el-table-column>
              <el-table-column label="任务名称" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.jobName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="投诉人" align="center" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.customName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="bodyguardName"
                label="投诉对象"
                align="center"
              >
              </el-table-column>
              <el-table-column label="投诉内容" align="center" width="160">
                <template slot-scope="scope">
                  <span>{{ scope.row.complainMemo }}</span>
                </template>
              </el-table-column>
              <el-table-column label="投诉时间" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.submitAt }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="180">
                <template slot-scope="scope">
                  <div class="disAround">
                    <div class="operateBtn" @click="handleEdit1(scope.row)">
                      处理
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div style="width: 100%">
          <div class="recommendation">意见反馈</div>
          <!-- <div class="dis">
            <div
              :class="['selectItem', active == 0 ? 'active' : '']"
              @click="selectStatus(0)"
            >
              待解决
            </div>
            <div
              :class="['selectItem', active == 1 ? 'active' : '']"
              @click="selectStatus(1)"
            >
              已解决
            </div>
          </div> -->
          <div class="tabBox">
            <el-table
              ref="scrollTable"
              :data="recommendation1"
              style="width: 100%"
            >
              <el-table-column label="账号类型" align="center">
                <template slot-scope="scope">
                  {{ scope.row.type == 1 ? "用户" : "保安" }}
                </template>
              </el-table-column>
              <el-table-column
                prop="accountPhone"
                label="联系方式"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="content" label="投诉与建议" align="center">
              </el-table-column>
              <el-table-column label="图片" align="center" width="300">
                <template slot-scope="scope">
                  <div
                    style="
                      display: flex;
                      flex-wrap: wrap;
                      justify-content: center;
                    "
                  >
                    <el-image
                      v-if="item"
                      :src="item"
                      alt=""
                      v-for="(item, index) in scope.row.img"
                      :key="index"
                      style="width: 50px; height: 50px; margin-left: 10px"
                      :preview-src-list="scope.row.img"
                    >
                    </el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="gmtCreate" label="创建时间" align="center">
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <!-- <div class="disAround">
                    <div
                      class="operateBtn"
                      @click="handleEdit1(scope.$index, scope.row)"
                    >
                      查看
                    </div>
                    <div
                      class="operateBtn"
                      @click="handleDelete(scope.$index, scope.row)"
                    >
                      取回
                    </div>
                    <div
                      class="operateBtn"
                      @click="handleDelete(scope.$index, scope.row)"
                    >
                      记录
                    </div>
                  </div> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 派单弹窗 -->
      <el-dialog
        title="派单设置"
        :visible.sync="dialogFormVisible1"
        width="800px"
      >
        <el-form ref="ruleForm" :model="ruleForm2">
          <el-row :gutter="4">
            <el-col :span="6">
              <el-form-item>
                <el-input
                  v-model="ruleForm2.name"
                  placeholder="请输入名称"
                  @focus="clearData"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-input
                  v-model="ruleForm2.phone"
                  placeholder="请输入手机号"
                  @focus="clearData"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="身份状态">
                <el-select v-model="ruleForm2.status" placeholder="请选择">
                  <el-option
                    v-for="item in tableData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <el-button type="primary" @click="getUserList()" class="btn"
                  >查询</el-button
                >
                <el-button @click="resetForm1()">重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="margin-bottom: 20px">
          需求人数：{{ selectData.membersNum }}，已参与人数：{{
            selectData.readiesNum
          }}
        </div>
        <div style="margin-bottom: 20px">搜索总数：{{ tableData1.length }}</div>
        <el-table
          ref="singleTable"
          :data="tableData1"
          style="width: 100%"
          highlight-current-row
          @current-change="selectItem"
          max-height="250"
        >
          <el-table-column align="center" width="50">
            <template slot-scope="scope">
              <div
                :class="[scope.row.id == selectUserID ? 'select' : 'noselect']"
              ></div>
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">{{
              scope.row.accountType == 0
                ? scope.row.companyName
                : scope.row.cardName
            }}</template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">{{
              scope.row.accountType == 0
                ? "企业"
                : scope.row.accountType == 1
                ? "企业员工"
                : "临勤"
            }}</template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 30px; text-align: right">
          <el-button type="primary" @click="allocation()" class="btn"
            >派单</el-button
          >
          <el-button @click="resetForm2()">取消</el-button>
        </div>
      </el-dialog>
      <!-- 记录弹窗 -->
      <el-dialog
        title="回访记录设置"
        :visible.sync="dialogFormVisible"
        width="600px"
      >
        <el-form
          label-position="right"
          :model="ruleForm1"
          :rules="rules"
          ref="ruleForm"
          style="margin: 0 auto"
        >
          <el-form-item label="反馈内容" prop="content">
            <el-input
              v-model="ruleForm1.content"
              type="textarea"
              placeholder="请输入"
              style="width: 280px"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="">
            <el-radio-group v-model="ruleForm1.select">
              <el-radio label="1">需再次回访</el-radio>
              <el-radio label="2">完结回访</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 分配弹窗 -->
      <el-dialog
        title="分配设置"
        :visible.sync="dialogFormVisible2"
        width="800px"
      >
        <el-form ref="ruleForm" :model="ruleForm3">
          <el-row :gutter="4">
            <el-col :span="6">
              <el-form-item>
                <el-input
                  v-model="ruleForm3.name"
                  placeholder="请输入名称/手机号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="部门">
                <el-cascader
                  :value="ruleForm3.status"
                  :props="cateProps"
                  :show-all-levels="false"
                  :options="tableData3"
                  @change="handleChange"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item>
                <el-button type="primary" @click="getUserList1()" class="btn"
                  >查询</el-button
                >
                <el-button @click="resetForm4()">重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table
          ref="singleTable"
          :data="tableData2"
          style="width: 100%"
          highlight-current-row
          @current-change="selectItem3"
          max-height="250"
        >
          <el-table-column align="center" width="50">
            <template slot-scope="scope">
              <div class="select" v-if="scope.row.id == selectUser1.id"></div>
            </template>
          </el-table-column>
          <el-table-column label="部门">
            <template slot-scope="scope">{{ scope.row.divisionName }}</template>
          </el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
        </el-table>
        <div style="margin-top: 30px; text-align: right">
          <el-button type="primary" @click="allocation1()" class="btn"
            >分配</el-button
          >
          <el-button @click="resetForm3()">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <div
      :style="{
        display: showModel == true ? 'block' : 'none',
        background: callType == 'shipin' ? '' : '#ccc',
      }"
      id="local-video"
      style="width: 650px; height: 500px; position: fixed; top: 20%; left: 25%"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          position: absolute;
          bottom: 20px;
          left: 0;
          color: #fff;
          width: 100%;
          z-index: 99;
        "
        v-if="showBtn"
      >
        <div style="text-align: center; cursor: pointer" @click="closeYin">
          <div
            style="
              width: 30px;
              height: 30px;
              background: #fff;
              text-align: center;
              line-height: 30px;
              border-radius: 100%;
              margin: 0 auto 5px;
            "
          >
            <svg
              v-if="isOpen"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 34 13"
              style="
                width: 20px;
                height: 30px;
                margin-top: -6px;
                margin-left: 4px;
              "
            >
              <path
                d="M2.58 14.496c.167 0 .304.136.304.303a9.637 9.637 0 0 0 9.638 9.639 9.637 9.637 0 0 0 9.639-9.639c0-.167.136-.303.303-.303h2.277c.167 0 .304.136.304.303 0 6.455-4.884 11.767-11.157 12.45v3.867h5.666c.52 0 .937.543.937 1.214v1.366c0 .167-.106.304-.235.304H4.789c-.13 0-.235-.137-.235-.304V32.33c0-.671.417-1.214.937-1.214h5.513V27.23C4.804 26.483 0 21.2 0 14.8c0-.168.137-.304.304-.304ZM12.522 0c3.563 0 6.451 2.854 6.451 6.375v8.5c0 3.521-2.888 6.375-6.45 6.375-3.564 0-6.452-2.854-6.452-6.375v-8.5C6.071 2.854 8.96 0 12.522 0Z"
                fill-rule="nonzero"
                fill="#363B4D"
                data-follow-fill="#363B4D"
              />
            </svg>
            <svg
              v-if="!isOpen"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 26 34"
              style="width: 20px; height: 20px; margin-top: 6px"
            >
              <path
                d="M2.58 14.496c.167 0 .304.136.304.303a9.637 9.637 0 0 0 9.638 9.639c1.02 0 2.004-.159 2.927-.453l2.229 2.23c-1.177.532-2.452.889-3.79 1.034v3.867h5.666c.52 0 .937.543.937 1.214v1.366c0 .167-.106.304-.235.304H4.789c-.13 0-.235-.137-.235-.304V32.33c0-.671.417-1.214.937-1.214h5.513V27.23C4.804 26.483 0 21.2 0 14.8c0-.168.137-.304.304-.304H2.58Zm.202-8.835 21.92 21.92a1.5 1.5 0 0 1-2.12 2.122L.661 7.783a1.5 1.5 0 0 1 2.12-2.122Zm21.96 8.835c.166 0 .303.136.303.303 0 3.251-1.24 6.213-3.271 8.439l-2.041-2.042a9.602 9.602 0 0 0 2.428-6.397c0-.167.136-.303.303-.303h2.277Zm-18.671.111 6.64 6.64a6.65 6.65 0 0 1-.189.003c-3.563 0-6.45-2.854-6.45-6.375l-.001-.268ZM12.522 0c3.563 0 6.451 2.854 6.451 6.375v8.5c0 1.55-.559 2.97-1.488 4.074L6.07 7.535v-1.16C6.071 2.854 8.96 0 12.522 0Z"
                fill-rule="nonzero"
                fill="#000"
                data-follow-fill="#FFF"
              />
            </svg>
          </div>
          <div>{{ isOpen == true ? "麦克风已开" : "麦克风已关" }}</div>
        </div>
        <div style="text-align: center; cursor: pointer" @click="closeModel">
          <div
            style="
              width: 30px;
              height: 30px;
              background: red;
              text-align: center;
              line-height: 30px;
              border-radius: 100%;
              margin-bottom: 5px;
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 34 13"
              style="width: 15px; height: 8px"
            >
              <path
                d="M33.05 4.075C30.75 1.521 25.24 0 18.322 0L15.76.01C8.834.01 3.312 1.522.974 4.076l-.091.11C-.561 5.937-.035 9.58 1.04 11.15c.679 1.011 1.379.985 1.68.9 2.374-.432 6.05-1.584 7.05-2.387l.068-.058.044-.078c.367-.608.276-1.258.187-1.812-.12-.744-.146-1.197.371-1.663.148-.139 1.005-.607 5.528-.66h1.944c4.616.043 5.492.509 5.653.66.528.48.47.916.354 1.656-.095.57-.2 1.206.161 1.817l.048.08.068.056c.987.8 4.655 1.959 6.958 2.373.315.104.926.138 1.557-.628 1.291-1.54 1.948-5.523.339-7.33Z"
                fill-rule="nonzero"
                fill="#fff"
                data-follow-fill="#FFF"
              />
            </svg>
          </div>
          <div>挂断</div>
        </div>
      </div>
    </div>
    <div v-if="isRule == false">
      <div class="bigText">欢迎使用咖德保安运营平台</div>
    </div>
  </div>
</template>

<script>
// import AMapLoader from "@amap/amap-jsapi-loader";
import TRTC from "trtc-sdk-v5";
const trtc = TRTC.create();
import * as GenerateTestUserSig from "../../debug/GenerateTestUserSig-es";
export default {
  components: {},
  data() {
    return {
      selectDate: [
        { name: "今日", key: "1" },
        { name: "昨日", key: "2" },
        { name: "本周", key: "3" },
        { name: "本月", key: "4" },
      ], // 选择的日期
      select: 1,
      active: 0,
      tableData: [
        { label: "企业", value: "0" },
        { label: "临勤", value: "2" },
      ],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      statisticsData: {}, // 统计数据
      overviewData: {}, // 经营概况
      interceptData: [], // 任务截停
      intercepttotalRows: 0, // 任务截停数量
      regulationData: [], // 规则列表
      waitdispatchlistData: [], // 违约待处理列表
      waitdispatchlisttotalRows: 0, // 违约待处理数量
      dispatchlistData: [], // 派单列表
      dispatchlisttotalRows: 0, // 派单数量
      followupData: [], // 回访列表
      followuptotalRows: 0, // 回访数量
      complainData: [], // 投诉处理列表
      complaintalRows: 0, // 投诉处理数量
      recommendation1: [], //投诉与建议
      dialogFormVisible1: false,
      ruleForm2: {
        name: "",
        phone: "",
        status: "",
      },
      allocationId: "",
      selectUserID: "",
      taskId: "",
      selectUser: {},
      time: "",
      dialogFormVisible: false,
      dialogFormVisible2: false,
      setId: "",
      ruleForm1: {
        content: "",
        select: "",
      },
      rules: {
        select: [{ required: true, message: "请选择", trigger: "change" }],
      },
      cateProps: {
        label: "name",
        value: "id",
        checkStrictly: true,
      },
      ruleForm3: {
        name: "",
        status: "",
      },
      allocationId1: "",
      selectUser1: {},
      ruleForm: {
        name: "",
        status: "",
      },
      selectModel: 3,
      selectData: {}, // 点击派单时选择的数据
      isRule: false,
      activeName: "first",
      rankingData: [],
      showUser: false,
      showBaoan: true,
      numData: [],
      map: null,
      zhengjian: "", //选择的证件
      level: "", //选择的等级
      articleName: "", //保安名称
      articlePhone: "", //保安手机号
      certificate: [], //证件列表
      ids: [], //等级列表
      selectAddress: {}, //地图选择的城市
      selectId: {}, //地图选择的证件
      pageSize: 3000, //城市级别一次性获取数量
      page: 1, //地图选择的证件
      numTotal: 0, //地图区域保安数量
      mapLoading: false,
      baoanPage: 1,
      baoanPageSize: 10,
      cityList: [], //省列表
      cityCode: "", //选择的省code
      cityCode1: "", //选择的城市code
      cityCode2: "", //选择的地区code
      city2: [], //地区列表
      city1: [], //城市列表
      baoanList: [],
      baoanTotal: 0,
      mapSize: 4.8,
      isFullscreen: false,
      showDown: false,
      showLeft: false,
      showAddress: "",
      map: null,
      polygons: {}, // 存储省份多边形 { '浙江省': polygon }
      datass: [
        { name: "北京", value: 80 },
        { name: "上海", value: 120 },
        { name: "广东", value: 200 },
        { name: "浙江", value: 150 },
        { name: "四川", value: 90 },
        { name: "湖北", value: 60 },
        { name: "陕西", value: 40 },
        // 更多省份...
      ],
      colors: ["#f0f9e8", "#bae4bc", "#7bccc4", "#43a2ca", "#0868ac"], // 5级颜色，从浅到深
      getInfo: false, //获取统计还是具体人数false-统计，true-具体人数
      callerUserID:
        window.location.hostname == "manager.baoanlailou.com"
          ? "kefu11"
          : "kefu99", //自己id
      calleeUserID: "", //对方 id
      SDKAppID: 1600107770, // TODO: Replace with your SDKAppID
      SecretKey:
        "57ca99f71de79294c3ffe4837fc4eb43f879a79d373f794c071dee5a5bd9ac87", // TODO: Replace with your SecretKey
      isInit: false,
      showModel: false,
      isOpen: true,
      showBtn: false,
      callType: "",
    };
  },
  components: {},
  async created() {
    // window._AMapSecurityConfig = {
    //   securityJsCode: "739e7614bf97603024b3be58b129f821"
    // };
    this.getCity();
    let list = this.Plugins.indexData();
    if (list.length != 0) {
      this.isRule = true;
    }
    this.time = Date.parse(new Date());
    this.statistics();
    this.overview();
    this.regulation();
    this.intercept();
    this.waitdispatchlist();
    this.dispatchlist();
    this.followup();
    this.complain();
    this.yijian();
    this.getCertificate();
    this.getList();
  },
  async beforeDestroy() {
    // 组件销毁时清除计时器
    clearInterval(this.timer);
    await trtc.stopLocalVideo();
    await trtc.stopLocalAudio();
    // trtc.exitRoom();
  },
  async mounted() {
    document.addEventListener("fullscreenchange", () => {
      if (!document.fullscreenElement) {
        this.isFullscreen = false;
        this.showDown = false;
        this.showLeft = false;
      }
    });
    // this.initMap999();
    // this.loadMap();
  },
  methods: {
    loadMap() {
      // 基于准备好的 DOM，初始化 echarts 实例
      var myChart = echarts.init(document.getElementById("map"));

      // 指定图表的配置项和数据
      var option = {
        title: {
          text: "全国各省份用户分布",
          subtext: "数据来源：示例数据",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["用户数量"],
        },
        visualMap: {
          min: 0,
          max: 500,
          left: "left",
          top: "bottom",
          text: ["高", "低"], // 文本，默认为数值文本
          calculable: true,
          inRange: {
            color: ["#e0ffff", "#006edd"], // 颜色渐变范围
          },
        },
        series: [
          {
            name: "用户数量",
            type: "map",
            mapType: "china",
            roam: false,
            label: {
              show: true,
            },
            data: this.datass,
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    checkAmapLoaded() {
      return new Promise((resolve, reject) => {
        if (window.AMap && window.AMap.DistrictSearch) {
          resolve();
        } else {
          setTimeout(() => {
            this.checkAmapLoaded().then(resolve).catch(reject);
          }, 100);
        }
      });
    },
    async initMap999() {
      // await this.checkAmapLoaded();
      // 初始化地图
      this.map = new AMap.Map("map", {
        zoom: 4,
        center: [106.573459, 35.858607],
        viewMode: "2D",
      });
      // // 加载中国行政区划
      this.loadDistrict();
    },
    loadDistrict() {
      AMap.plugin(["AMap.DistrictSearch"], function () {
        const district = new AMap.DistrictSearch({
          level: "province",
          extensions: "geometry",
          subdistrict: 0,
        });
        district.search("中国", (status, result) => {
          console.log("方法被调用:", status, result);
          if (status === "complete") {
            const provinces = result.districtList[0].districtList;
            provinces.forEach((item) => {
              if (item.level === "province") {
                this.drawProvince(item);
              }
            });
          }
        });
      });
    },
    drawProvince(item) {
      const { name, boundaries } = item;
      if (!boundaries || boundaries.length === 0) return;
      // 查找对应数据
      const dataItem = this.datass.find((d) => d.name === name) || { value: 0 };
      const color = this.getColor(dataItem.value);
      // 创建多边形
      const polygon = new AMap.Polygon({
        map: this.map,
        strokeColor: "#fff",
        strokeWeight: 1,
        fillColor: color,
        fillOpacity: 0.8,
        path: boundaries[0], // 取第一个外环
      });
      // 存储多边形用于后续操作
      this.polygons[name] = polygon;
      // 鼠标悬停显示信息
      polygon.on("mouseover", () => {
        this.map.setZoomAndCenter(6, this.getCenter(boundaries[0]));
        this.showTooltip(name, dataItem.value);
      });
      polygon.on("mouseout", () => {
        this.hideTooltip();
      });
      // 可选：点击事件
      polygon.on("click", () => {
        alert(`${name}: ${dataItem.value}`);
      });
    },
    getCenter(path) {
      // 简单取第一个点作为中心（实际可用 AMap.GeometryUtil 的 centroid）
      return [path[0][0], path[0][1]];
    },
    getColor(value) {
      const max = Math.max(...this.datass.map((d) => d.value));
      const levels = this.colors.length;
      const step = max / levels;
      const index = Math.floor(value / step);
      return this.colors[Math.min(index, levels - 1)];
    },
    showTooltip(name, value) {
      if (this.tooltip) this.hideTooltip();
      this.tooltip = new AMap.Marker({
        map: this.map,
        position: this.getCenter(
          Object.keys(this.polygons).find((k) => k === name)
            ? this.polygons[name].getPath()[0]
            : [0, 0]
        ),
        content: `
          <div style="
            background: rgba(0,0,0,0.8);
            color: white;
            padding: 8px 12px;
            border-radius: 4px;
            font-size: 12px;
            white-space: nowrap;
          ">
            ${name}: <b>${value}</b>
          </div>
        `,
        offset: new AMap.Pixel(0, -30),
      });
    },
    hideTooltip() {
      if (this.tooltip) {
        this.tooltip.setMap(null);
        this.tooltip = null;
      }
    },
    beforeDestroy() {
      if (this.map) {
        this.map.destroy();
      }
    },
    // 测试**********************************************
    selectShow() {
      this.showDown = !this.showDown;
    },
    selectShow1() {
      this.showLeft = !this.showLeft;
    },
    //城市输入框清空
    clearCity() {
      this.cityCode2 = "";
      this.mapSize = 4.8;
      for (var i = 0; i < this.cityList.length; i++) {
        if (this.cityCode == this.cityList[i].adcode) {
          this.selectAddress = this.cityList[i];
        }
      }
    },
    //城市输入框清空
    clearCity1() {
      this.mapSize = 6;
      for (var i = 0; i < this.city1.length; i++) {
        if (this.cityCode1 == this.city1[i].adcode) {
          this.selectAddress = this.city1[i];
        }
      }
    },
    //证件选择清空
    clearZhen() {
      this.level = "";
    },
    //获取省份
    getCity() {
      let param = {
        type: 0,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.cityList = data;
          this.cityCode = data[0].adcode;
          this.selectAddress = data[0];
          this.showAddress = this.selectAddress.name;
          this.getBaoanNum();
        })
        .catch()
        .finally();
    },
    //获取城市
    getcity1() {
      let param = {
        type: 1,
        adcode: this.cityCode,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.city1 = data;
        })
        .catch()
        .finally();
    },
    //获取地区
    getcity2() {
      let param = {
        type: 2,
        adcode: this.cityCode1,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.city2 = data;
        })
        .catch()
        .finally();
    },
    //省下拉
    selectCity(val) {
      this.cityCode = val;
      this.cityCode1 = "";
      this.cityCode2 = "";
      this.mapSize = 4.8;
      for (var i = 0; i < this.cityList.length; i++) {
        if (val == this.cityList[i].adcode) {
          this.selectAddress = this.cityList[i];
        }
      }
      this.getcity1();
    },
    //城市下拉
    selectCity1(val) {
      if (val == "") {
        return;
      } else {
        this.cityCode1 = val;
        this.cityCode2 = "";
        this.mapSize = this.cityCode == "110000" ? 4.8 : 6;
        this.mapSize = this.mapSize + (this.cityCode == "110000" ? 1.3 : 2);
        for (var i = 0; i < this.city1.length; i++) {
          if (val == this.city1[i].adcode) {
            this.selectAddress = this.city1[i];
          }
        }
        this.getcity2();
      }
    },
    //地区下拉
    selectCity2(val) {
      this.mapSize = this.mapSize + (this.cityCode == "110000" ? 1.3 : 2);
      for (var i = 0; i < this.city2.length; i++) {
        if (val == this.city2[i].adcode) {
          this.selectAddress = this.city2[i];
        }
      }
    },
    goAskair(val) {
      this.$router.push({
        path: "askari",
        query: {
          name: val.accountType == 0 ? val.companyName : val.cardName,
        },
      });
    },
    moveToEnd(arr, element) {
      const index = arr.indexOf(element);
      if (index > -1) {
        arr.splice(index, 1); // 从原位置删除
        arr.push(element); // 添加到末尾
      }
      return arr;
    },
    //点击保安列表绘制地图
    seeItem(val) {
      let arr1 = [];
      for (var i = 0; i < this.baoanList.length; i++) {
        arr1.push(this.baoanList[i]);
      }
      let arr = this.moveToEnd(arr1, val);
      let obj = {
        list: arr,
      };
      this.initMap(3, obj);
    },
    //保安列表分页操作
    baoanHandleCurrentChange(val) {
      this.baoanPage = val;
      this.getList();
    },
    //保安列表
    getList() {
      let param = {
        page: this.baoanPage,
        pageSize: this.baoanPageSize,
        showLoginOff: 0,
        careerType: this.zhengjian,
        name: this.articleName,
        phone: this.articlePhone,
        isWorkBench: 1, //是否工作台
        levelType: this.level,
      };
      if (this.cityCode2 != "") {
        param.lastLoginAreaCode = this.cityCode2;
      } else if (this.cityCode1 != "") {
        param.lastLoginCityCode = this.cityCode1;
      } else {
        param.lastLoginProvinceCode =
          this.cityCode == 100000 ? "" : this.cityCode;
      }
      this.$axios
        .post(`/admapi/bodyguard/list`, param)
        .then(({ data }) => {
          let arr = data.items;
          for (var i = 0; i < arr.length; i++) {
            arr[i].log = arr[i].lastLoginLog;
            arr[i].lat = arr[i].lastLoginLat;
            arr[i].cityName = arr[i].lastLoginCity;
            arr[i].bodyguardName =
              arr[i].accountType == 0 ? arr[i].companyName : arr[i].cardName;
          }
          this.baoanList = arr;
          this.baoanTotal = data.page.totalRows || 0;
        })
        .catch()
        .finally();
    },
    //保安地图搜索
    serch() {
      this.page = 1;
      this.numData = [];
      if (
        this.articleName != "" ||
        this.articlePhone != "" ||
        this.cityCode2 != ""
      ) {
        this.getInfo = true;
      } else {
        this.getInfo = false;
      }
      this.getBaoanNum();
      this.getList();
      this.showAddress = this.selectAddress.name;
    },
    //全屏
    big() {
      const elem = document.getElementById("bigPage"); // 获取地图容器元素
      if (elem.requestFullscreen) {
        elem
          .requestFullscreen() // 标准方法
          .then(() => {
            this.isFullscreen = true;
            // 全屏后可以立即添加内容
          });
      }
    },
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        this.isFullscreen = false;
      }
    },
    //获取当前城市保安数据
    getBaoanNum() {
      let param = {
        careerType: this.zhengjian,
        levelType: this.level,
        name: this.articleName,
        phone: this.articlePhone,
        page: this.page,
        returnType:
          this.articleName != "" ||
          this.articlePhone != "" ||
          this.getInfo == true
            ? 2
            : 1,
        pageSize: this.pageSize,
      };
      if (this.cityCode2 != "") {
        param.areaCode = this.cityCode2;
      } else if (this.cityCode1 != "") {
        param.cityCode = this.cityCode1;
      } else {
        param.provinceCode =
          this.articleName != "" || this.articlePhone != ""
            ? ""
            : this.cityCode;
      }
      this.$axios
        .post(`/admapi/workbenches/bodyguardmap`, param)
        .then(({ data }) => {
          let arr = this.numData;
          arr.push(...data.records);
          this.numData = arr;
          this.numTotal = data.total;
          if (this.numData.length == 0) {
            this.$message({
              message: "您搜索条件，未检索到数据。",
              type: "warning",
            });
            if (this.cityCode != "100000") {
              const size = this.mapSize + (this.cityCode == "110000" ? 1.3 : 2);
              this.mapSize = size;
              this.map.setZoom(this.mapSize);
            }
          }
          if (this.numData.length == this.numTotal) {
            if (
              this.articleName != "" ||
              this.articlePhone != "" ||
              this.getInfo == true
            ) {
              let obj = {
                list: this.numData,
              };
              this.initMap(3, obj);
            } else {
              this.initMap(1);
            }
          } else {
            if (this.cityCode != "100000") {
              this.page++;
              this.getBaoanNum();
            }
          }
        })
        .catch()
        .finally();
    },
    //证件下拉
    selectCertificate(val) {
      this.level = "";
      for (var i = 0; i < this.certificate.length; i++) {
        if (val == this.certificate[i].id) {
          this.selectId = this.certificate[i];
        }
      }
      this.getLevel();
    },
    //获取等级
    getLevel() {
      let param = {
        key: this.selectId.lvKey,
        orderColumn: "sort",
        isAsc: "1",
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          this.ids = data;
        })
        .catch()
        .finally();
    },
    //分页数据渲染地图不会重新渲染
    initData(markers) {
      let arr1 = markers;
      let maskerIn;
      arr1.forEach((marker) => {
        maskerIn = new AMap.Marker({
          position: new AMap.LngLat(marker.log, marker.lat), // 坐标点位置
          icon: new AMap.Icon({
            // 图标尺寸
            size: new AMap.Size(44, 54),
            // 图标的取图地址
            image: `${require("@/assets/imgs/baoan.png")}`,
            // 图标所用图片大小
            imageSize: new AMap.Size(44, 54),
            // 图标取图偏移量
            imageOffset: new AMap.Pixel(0, 0),
          }),
          // extData: marker
          map: this.map, // 所属地图
        });
        var content = [];
        content.push("手机号：" + marker.phone);
        content.push("姓名：" + marker.bodyguardName);
        content.push("最近登录：" + marker.lastLoginTime);
        content.push("最近城市：" + marker.cityName);
        content.push("详细地址：" + marker.lastLoginAddress);
        content.push("使用机型：" + marker.lastPhoneModel);
        content.push(
          "<a href='/askariDetail?id=" +
            marker.bodyguardId +
            "''" +
            " style='display:block;width:60px;text-decoration: none;heigth:20px;line-height: 20px;text-align: center;color: #fff;background: #0091ff;border-radius: 10px;margin-left:auto;font-size:10px'>查看更多</a>"
        );
        var infoWindow = new AMap.InfoWindow({
          isCustom: true, //使用自定义窗体
          content: createInfoWindow(content.join("<br/>")),
          offset: new AMap.Pixel(40, -18),
        });
        maskerIn.content = createInfoWindow(content.join("<br/>"));
        maskerIn.on("click", markerClick);
        //进来默认显示窗体
        // maskerIn.emit("click", { target: maskerIn });
        //构建自定义信息窗体
        function createInfoWindow(content) {
          var info = document.createElement("div");
          info.className = "custom-info input-card content-window-card";
          //可以通过下面的方式修改自定义窗体的宽高
          info.style.width = "300px";
          // 定义顶部标题
          var top = document.createElement("div");
          var closeX = document.createElement("img");
          top.className = "info-top";
          closeX.src = "https://webapi.amap.com/images/close2.gif";
          closeX.onclick = closeInfoWindow;
          top.appendChild(closeX);
          info.appendChild(top);
          // 定义中部内容
          var middle = document.createElement("div");
          middle.className = "info-middle";
          middle.style.backgroundColor = "white";
          middle.innerHTML = content;
          info.appendChild(middle);
          // 定义底部内容
          var bottom = document.createElement("div");
          bottom.className = "info-bottom";
          bottom.style.position = "relative";
          bottom.style.top = "0px";
          bottom.style.margin = "0 auto";
          var sharp = document.createElement("img");
          sharp.src = "https://webapi.amap.com/images/sharp.png";
          bottom.appendChild(sharp);
          info.appendChild(bottom);
          return info;
        }
        //关闭信息窗体
        function closeInfoWindow() {
          this.map.clearInfoWindow();
        }
        function markerClick(e) {
          infoWindow.setContent(e.target.content);
          infoWindow.open(this.map, e.target.getPosition());
        }
      });
    },
    //保安分布图重置
    resetSearch() {
      this.page = 1;
      this.mapSize = 4.8;
      this.cityCode = this.cityList[0].adcode;
      this.selectAddress = this.cityList[0];
      this.showAddress = this.cityList[0].name;
      this.cityCode1 = "";
      this.cityCode2 = "";
      this.articleName = "";
      this.zhengjian = "";
      this.level = "";
      this.articlePhone = "";
      this.numData = [];
      this.getInfo = false;
      this.getBaoanNum();
      this.getList();
    },
    //绘制地图
    initMap(val, val1) {
      let chartDom = "";
      if (val == 1 || val == 3) {
        chartDom = "map";
      } else {
        chartDom = "map1";
      }
      let map = new AMap.Map(chartDom, {
        resizeEnable: true,
        zoom: this.mapSize,
        center: [this.selectAddress.log, this.selectAddress.lat], // 初始化地图中心点坐标
      });
      if (val == 1 || val == 2) {
        let mzg = [];
        this.numData.forEach((data) => {
          if (data.log && data.lat) {
            var markerContent =
              '<div class="custom-content-marker">' + data.value + "</div>";
            const marker = new AMap.Marker({
              position: new AMap.LngLat(data.log, data.lat),
              map: map,
              content: markerContent,
            });
            mzg.push(marker);
            marker.on("click", async () => {
              if (val == 2) {
                return;
              }
              console.log(data);
              if (this.cityCode == "" || this.cityCode == 100000) {
                this.cityCode = data.provinceCode;
                this.showAddress = data.provinceName;
                this.getcity1();
              } else if (this.cityCode1 == "") {
                this.cityCode1 = data.cityCode;
                this.showAddress = data.cityName;
                this.getcity2();
              } else {
                this.cityCode2 = data.areaCode;
                this.showAddress = data.areaName;
              }
              if (data.value <= 100) {
                this.getInfo = true;
              }
              this.selectAddress = data;
              this.numData = [];
              this.getBaoanNum();
              this.getList();
            });
          }
        });
        if (this.cityCode != "100000") {
          const size = this.mapSize + (this.cityCode == "110000" ? 1.3 : 2);
          this.mapSize = size;
          map.setFitView(mzg, [100, 100, 100, 100]);
          map.setZoom(this.mapSize);
        }
      } else {
        map.setZoom(9);
        const markers = val == 3 ? val1.list : this.numData;
        let maskerIn;
        markers.forEach((marker) => {
          maskerIn = new AMap.Marker({
            position: [marker.log, marker.lat], // 坐标点位置
            icon: new AMap.Icon({
              // 图标尺寸
              size: new AMap.Size(44, 54),
              // 图标的取图地址
              image: `${require("@/assets/imgs/baoan.png")}`,
              // 图标所用图片大小
              imageSize: new AMap.Size(44, 54),
              // 图标取图偏移量
              imageOffset: new AMap.Pixel(0, 0),
            }),
            map: map, // 所属地图
          });
          var content = [];
          content.push("手机号：" + marker.phone);
          content.push("姓名：" + marker.bodyguardName);
          content.push("最近登录：" + marker.lastLoginTime);
          content.push("最近城市：" + marker.cityName);
          content.push("详细地址：" + marker.lastLoginAddress);
          content.push("使用机型：" + marker.lastPhoneModel);
          // <div data-id=
          //     ${marker.maniacCode} style='display:${
          //     marker.maniacCode && marker.maniacCode != "" ? "block" : "none"
          //   };margin-left:10px;width:60px;heigth:20px;line-height: 20px;text-align: center;color: #fff;background: #0091ff;border-radius: 10px;font-size:10px' id='shipin' class='btn-detail'>视频通话</div><div data-id=
          //     ${marker.maniacCode} style='display:${
          //     marker.maniacCode && marker.maniacCode != "" ? "block" : "none"
          //   };margin-left:10px;width:60px;heigth:20px;line-height: 20px;text-align: center;color: #fff;background: #0091ff;border-radius: 10px;font-size:10px' id='yuyin' class='btn-detail1'>语音通话</div>
          content.push(
            `<div style='display:flex;justify-content: end;'><a href='/askariDetail?id=${
              marker.bodyguardId || marker.id
            }' style='display:inline-block;width:60px;text-decoration: none;heigth:20px;line-heigth: 20px;text-align: center;color: #fff;background: #0091ff;border-radius: 10px;font-size:10px;margin-left:10px'>查看更多</a></div>`
          );
          var infoWindow = new AMap.InfoWindow({
            isCustom: true, //使用自定义窗体
            content: createInfoWindow(content.join("<br/>")),
            offset: new AMap.Pixel(40, -18),
          });
          window.markerCache = window.markerCache || {};
          window.markerCache[marker] = marker;
          maskerIn.content = createInfoWindow(content.join("<br/>"));
          maskerIn.on("click", markerClick);
          //进来默认显示窗体
          maskerIn.emit("click", { target: maskerIn });
          //构建自定义信息窗体
          window.handleCall = (id) => {
            const data = window.markerCache[id];
            if (data) {
              this.call(data); // 调用 Vue 实例中的 call 方法
            } else {
              console.error("未找到对应数据");
            }
          };
          const shipin = document.getElementById("shipin");
          const yuyin = document.getElementById("yuyin");
          if (
            shipin != null ||
            shipin != undefined ||
            yuyin != null ||
            yuyin != undefined
          ) {
            shipin.addEventListener("click", this.dianji);
            yuyin.addEventListener("click", this.dianji1);
          }
          function createInfoWindow(content) {
            var info = document.createElement("div");
            info.className = "custom-info input-card content-window-card";
            //可以通过下面的方式修改自定义窗体的宽高
            info.style.width = "300px";
            // 定义顶部标题
            var top = document.createElement("div");
            var closeX = document.createElement("img");
            top.className = "info-top";
            closeX.src = "https://webapi.amap.com/images/close2.gif";
            closeX.onclick = closeInfoWindow;
            top.appendChild(closeX);
            info.appendChild(top);
            // 定义中部内容
            var middle = document.createElement("div");
            middle.className = "info-middle";
            middle.style.backgroundColor = "white";
            middle.innerHTML = content;
            info.appendChild(middle);
            // 定义底部内容
            var bottom = document.createElement("div");
            bottom.className = "info-bottom";
            bottom.style.position = "relative";
            bottom.style.top = "0px";
            bottom.style.margin = "0 auto";
            var sharp = document.createElement("img");
            sharp.src = "https://webapi.amap.com/images/sharp.png";
            bottom.appendChild(sharp);
            info.appendChild(bottom);
            return info;
          }
          //关闭信息窗体
          function closeInfoWindow() {
            map.clearInfoWindow();
          }
          function markerClick(e) {
            infoWindow.setContent(e.target.content);
            infoWindow.open(map, e.target.getPosition());
          }
        });
        //点击坐标放大到点击位置
        map.setFitView(null, true, [210, 50, 100, 50]);
      }
      this.map = map;
    },
    async dianji(e) {
      const target = e.target;
      if (target.classList.contains("btn-detail")) {
        const id = target.getAttribute("data-id");
        console.log("视频点击", id);
        this.calleeUserID = id;
        this.call();
      }
    },
    async dianji1(e) {
      const target = e.target;
      if (target.classList.contains("btn-detail1")) {
        const id = target.getAttribute("data-id");
        console.log("语音点击", id);
        this.calleeUserID = id;
        this.call1();
      }
    },
    async call() {
      this.callType = "shipin";
      try {
        const { userSig } = GenerateTestUserSig.genTestUserSig({
          userID: this.calleeUserID,
          SDKAppID: Number(this.SDKAppID),
          SecretKey: this.SecretKey,
        });
        await trtc.enterRoom({
          sdkAppId: Number(this.SDKAppID),
          userId: this.calleeUserID,
          userSig,
          roomId: 8888,
        });
        console.log("enter room successfully");
        this.showModel = true;
        const view = "local-video";
        await trtc.startLocalVideo({ view });
        await trtc.startLocalAudio();
        setTimeout(() => {
          this.showBtn = true;
        }, 400);
        setTimeout(() => {
          // trtc.exitRoom();
          const { userSig } = GenerateTestUserSig.genTestUserSig({
            userID: "789910",
            SDKAppID: Number(this.SDKAppID),
            SecretKey: this.SecretKey,
          });
          trtc.enterRoom({
            sdkAppId: Number(this.SDKAppID),
            userId: "789910",
            userSig,
            roomId: 8888,
          });
        }, 2000);
      } catch (error) {
        console.error("failed to enter room " + error);
      }
    },
    async call1() {
      this.callType = "yuyin";
      try {
        const { userSig } = GenerateTestUserSig.genTestUserSig({
          userID: this.calleeUserID,
          SDKAppID: Number(this.SDKAppID),
          SecretKey: this.SecretKey,
        });
        await trtc.enterRoom({
          sdkAppId: Number(this.SDKAppID),
          userId: this.calleeUserID,
          userSig,
          roomId: 8888,
        });
        console.log("enter room successfully");
        this.showModel = true;
        setTimeout(() => {
          this.showBtn = true;
        }, 400);
        await trtc.startLocalAudio();
      } catch (error) {
        console.error("failed to enter room " + error);
      }
    },
    async closeModel() {
      this.showModel = false;
      this.showBtn = false;
      await trtc.stopLocalVideo();
      await trtc.stopLocalAudio();
      trtc.exitRoom();
    },
    async closeYin() {
      if (this.isOpen == true) {
        this.isOpen = false;
        await trtc.stopLocalAudio();
      } else {
        this.isOpen = true;
        await trtc.startLocalAudio();
      }
    },
    // 记录弹窗关闭
    resetForm() {
      this.ruleForm1.content = "";
      this.ruleForm1.select = "";
      this.dialogFormVisible = false;
    },
    // 派单弹窗关闭
    resetForm2() {
      this.selectUserID = "";
      this.allocationId = "";
      this.taskId = "";
      this.ruleForm2.name = "";
      this.ruleForm2.status = "";
      this.ruleForm2.phone = "";
      this.dialogFormVisible1 = false;
    },
    // 选择派单人
    selectItem(val) {
      this.selectUserID = val == null ? "" : val.id;
    },
    //取消派单
    resetForm1() {
      this.selectUser = {};
      this.ruleForm2.name = "";
      this.ruleForm2.phone = "";
      this.ruleForm2.status = "";
      this.getUserList();
    },
    //点击派单
    handleEdit(val, val1) {
      this.selectModel = val1;
      this.selectData = val;
      this.allocationId = val.jobNo;
      this.taskId = val.id;
      this.getUserList();
      this.dialogFormVisible1 = true;
    },
    // 点击派单提交
    allocation() {
      if (!this.selectUserID) {
        this.$message({
          message: "请选择保安",
          type: "warning",
        });
        return;
      }
      let param = {
        jobId: this.taskId,
        bodygurardId: this.selectUserID,
      };
      this.$axios
        .post(`/admapi/dispatchjob/add`, param)
        .then(({ data }) => {
          this.$message({
            message: "派单成功",
            type: "success",
          });
          if (this.selectModel == 3) {
            this.intercept();
          } else if (this.selectModel == 4) {
            this.waitdispatchlist();
          } else {
            this.dispatchlist();
          }
        })
        .catch()
        .finally(() => {
          this.selectUserID = "";
          this.allocationId = "";
          this.taskId = "";
          this.dialogFormVisible1 = false;
        });
    },
    //倒计时结束
    hilarity() {
      this.intercept();
    },
    //获取证件列表
    getCertificate() {
      let param = {
        key: "pricePremiumType_certs",
        orderColumn: "sort",
        isAsc: "1",
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          let arr = JSON.parse(data[0].propValue);
          this.certificate = arr;
        })
        .catch()
        .finally();
    },
    statistics() {
      this.$axios
        .post(`/admapi/workbenches/statistics`)
        .then(({ data }) => {
          this.statisticsData = data;
        })
        .catch()
        .finally(() => {});
    },
    yijian() {
      let param = {
        page: 1,
        pageSize: 5,
      };
      this.$axios
        .post(`/admapi/workbenches/opinions`, param)
        .then(({ data }) => {
          let arr = data.items || [];
          for (var i = 0; i < arr.length; i++) {
            arr[i].img = arr[i].img
              .substring(1, arr[i].img.length - 1) // 去掉 `"[` 和 `]"`
              .split(", ") // 按逗号+空格分割
              .map((url) => url.trim()); // 去除可能的空格;
          }
          this.recommendation1 = arr;
        })
        .catch()
        .finally(() => {});
    },
    overview() {
      let param = {
        type: this.select,
      };
      this.$axios
        .post(`/admapi/workbenches/overview`, param)
        .then(({ data }) => {
          this.overviewData = data;
        })
        .catch()
        .finally(() => {});
    },
    regulation() {
      let param = {
        page: 1,
        pageSize: 10,
      };
      this.$axios
        .post(`/admapi/setrule/list`, param)
        .then(({ data }) => {
          this.regulationData = data;
        })
        .catch()
        .finally();
    },
    intercept() {
      let now = new Date().getTime() / 1000;
      let param = {
        page: 1,
        pageSize: 5,
      };
      this.$axios
        .post(`/admapi/workbenches/intercept/list`, param)
        .then(({ data }) => {
          this.intercepttotalRows = data.page.totalPages;
          let arr = data.items;
          for (var s = 0; s < arr.length; s++) {
            if (arr[s].leaveTime == 0) {
              arr[s].realActionAt = new Date(
                arr[s].realActionAt.replace(/-/g, "/")
              );
              arr[s].realActionAt = arr[s].realActionAt.getTime() / 1000;
              arr[s].leaveTime = arr[s].realActionAt - now;
            }
          }
          this.timer = setInterval(() => {
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].realActionAt != null) {
                if (arr[i].leaveTime > 0) {
                  arr[i].leaveTime--;
                } else {
                  this.hilarity();
                  clearInterval(this.timer); // 倒计时结束，停止计时器
                }
              }
            }
          }, 1000);
          this.interceptData = arr;
        })
        .catch()
        .finally(() => {});
    },
    waitdispatchlist() {
      let param = {
        page: 1,
        pageSize: 5,
      };
      this.$axios
        .post(`/admapi/workbenches/violate/waitdispatchlist`, param)
        .then(({ data }) => {
          this.waitdispatchlistData = data.items;
          this.waitdispatchlisttotalRows = data.page.totalRows;
        })
        .catch()
        .finally(() => {});
    },
    dispatchlist() {
      let param = {
        page: 1,
        pageSize: 5,
      };
      this.$axios
        .post(`/admapi/workbenches/job/dispatchlist`, param)
        .then(({ data }) => {
          let arr = data.items;
          for (var i = 0; i < arr.length; i++) {
            arr[i].selectTime = Date.parse(arr[i].jobEnd) - this.time;
            if (Date.parse(arr[i].jobEnd) - this.time < 0) {
              arr[i].time = (Date.parse(arr[i].jobEnd) - this.time) * -1;
            } else {
              arr[i].time = Date.parse(arr[i].jobEnd) - this.time;
            }
            var theTime = parseInt(arr[i].time / 1000); // 秒
            var middle = 0; // 分
            var hour = 0; // 小时
            var day = 0; // 天
            if (theTime >= 60) {
              middle = parseInt(theTime / 60);
              theTime = parseInt(theTime % 60);
              if (middle >= 60) {
                hour = parseInt(middle / 60);
                middle = parseInt(middle % 60);
                if (hour >= 24) {
                  day = parseInt(hour / 24);
                  hour = parseInt(hour % 24);
                }
              }
            }
            var result = "" + parseInt(theTime) + "秒";
            arr[i].theTime = parseInt(theTime);
            arr[i].hour1 = 0;
            arr[i].middle = 0;
            arr[i].day = 0;
            if (middle > 0) {
              result = "" + parseInt(middle) + "分" + result;
              arr[i].middle = parseInt(middle);
            }
            if (hour > 0) {
              result = "" + parseInt(hour) + "小时" + result;
              arr[i].hour1 = parseInt(hour);
            }
            if (day > 0) {
              result = "" + parseInt(day) + "天" + result;
              arr[i].day = parseInt(day);
            }
          }
          this.dispatchlistData = arr;
          this.dispatchlisttotalRows = data.page.totalPages;
        })
        .catch()
        .finally(() => {});
    },
    followup() {
      let param = {
        page: 1,
        pageSize: 5,
      };
      this.$axios
        .post(`/admapi/workbenches/followup/list`, param)
        .then(({ data }) => {
          this.followupData = data.items;
          this.followuptotalRows = data.page.totalPages;
        })
        .catch()
        .finally(() => {});
    },
    complain() {
      let param = {
        page: 1,
        pageSize: 5,
      };
      this.$axios
        .post(`/admapi/workbenches/complain/list`, param)
        .then(({ data }) => {
          this.complainData = data.items;
          this.complaintalRows = data.page.totalRows;
        })
        .catch()
        .finally(() => {});
    },
    // 派单的客服列表
    getUserList() {
      let param = {
        page: 1,
        pageSize: 1000,
        accountType: this.ruleForm2.status,
        cardName: this.ruleForm2.name,
        phone: this.ruleForm2.phone,
        jobNo: this.allocationId,
      };
      this.$axios
        .post(`/admapi/bodyguard/dispathMemberlist`, param)
        .then(({ data }) => {
          this.tableData1 = data.items;
          this.selectUserID = "";
        })
        .catch()
        .finally();
    },
    //倒计时暂停
    stop(val) {
      let param = {
        id: val.id,
        leaveTime: val.leaveTime,
      };
      this.$axios
        .post(`/admapi/workbenches/intercept/onoff`, param)
        .then(({ data }) => {
          this.intercept();
          //点击暂停
          // let arr = this.interceptData;
          // if (val.realActionAt != null) {
          //   clearInterval(this.timer);
          //   for (var v = 0; v < arr.length; v++) {
          //     if (arr[v].id == val.id) {
          //       arr[v].realActionAt = null;
          //     }
          //   }
          //   this.interceptData = arr;
          // } else {
          //   // 点击启动
          //   console.log("2222");
          //   this.timer = setInterval(() => {
          //     for (var i = 0; i < arr.length; i++) {
          //       // 给值改变页面文案
          //       if (arr[v].id == val.id) {
          //         arr[v].realActionAt = arr[i].leaveTime;
          //       }
          //       if (arr[i].realActionAt != null) {
          //         if (arr[i].leaveTime > 0) {
          //           arr[i].leaveTime--;
          //         } else {
          //           clearInterval(this.timer); // 倒计时结束，停止计时器
          //         }
          //       }
          //     }
          //   }, 1000);
          //   this.interceptData = arr;
          // }
        })
        .catch()
        .finally(() => {});
    },
    //立即发布拦截订单
    nowSend(val) {
      let param = {
        id: val.id,
      };
      this.$axios
        .post(`/admapi/workbenches/intercept/publishnow/${val.id}`, param)
        .then(({ data }) => {
          this.intercept();
        })
        .catch()
        .finally(() => {});
    },
    //选择日期
    dateSelect(val) {
      this.select = val.key;
      this.overview();
    },
    //投诉建议的状态切换
    selectStatus(val) {
      this.active = val;
    },
    recommendation() {},
    //设置规则
    goRegulation() {
      this.$router.push("/regulation");
    },
    //查看违约规则
    goViolation1() {
      this.$router.push("/violation");
    },
    //查看违约
    goDetail(val) {
      this.$router.push({
        path: "/defaultDetail",
        query: {
          id: val.id,
        },
      });
    },
    //查看违约
    goDetail1(val) {
      this.$router.push({
        path: "/taskDetail",
        query: {
          id: val.id,
        },
      });
    },
    clearData() {
      this.selectUserID = "";
      this.$refs.singleTable.clearSelection();
    },
    //查看回访
    goDetail2(val) {
      this.$router.push({
        path: "/followUpDetail",
        query: {
          id: val.id,
        },
      });
    },
    //记录
    set(val) {
      this.dialogFormVisible = true;
      this.setId = val.id;
    },
    //提交记录
    submitForm(formName) {
      let param = {
        id: this.setId,
        status: this.ruleForm1.select,
        memo: this.ruleForm1.content,
      };
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post(`/admapi/followup/record`, param)
            .then(({ data }) => {
              this.$message({
                message: "记录成功",
                type: "success",
              });
            })
            .catch()
            .finally(() => {
              this.dialogFormVisible = false;
            });
        }
      });
    },
    // 分配弹窗列表
    getUserList1() {
      let param = {
        page: 1,
        pageSize: 1000,
        pageNo: 1,
        queryParams: [
          { name: "name", type: "input", value: this.ruleForm3.name },
          { name: "phone", type: "input", value: this.ruleForm3.name },
        ],
      };
      if (this.ruleForm3.status != "") {
        param.queryParams.push({
          name: "division_id",
          type: "select",
          values: [
            {
              itemKey: this.ruleForm3.status,
            },
          ],
        });
      }
      this.$axios
        .post(`admapi/sys/users/list`, param)
        .then(({ data }) => {
          this.tableData2 = data.items;
        })
        .catch()
        .finally();
    },
    //分配的下拉列表
    getdepartment() {
      let param = {
        page: 1,
        pageSize: 1000,
        queryParams: [
          { name: "name", type: "input", value: this.ruleForm.name },
        ],
      };
      this.$axios
        .post(`/admapi/division/treelist`, param)
        .then(({ data }) => {
          this.tableData3 = data;
        })
        .catch()
        .finally();
    },
    // 分配
    stop1(val) {
      this.$confirm("是否分配", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.getUserList1();
          this.getdepartment();
          this.dialogFormVisible2 = true;
          this.allocationId1 = val.id;
        })
        .catch(() => {});
    },
    //提交分配
    allocation1() {
      if (!this.selectUser1.id) {
        this.$message({
          message: "请选择客服",
          type: "warning",
        });
        return;
      }
      let param = {
        id: this.allocationId1,
        userId: this.selectUser1.id,
      };
      this.$axios
        .post(`/admapi/followup/allocation`, param)
        .then(({ data }) => {
          this.$message({
            message: "分配成功",
            type: "success",
          });
          this.dialogFormVisible2 = false;
          this.followup();
          this.selectUser1 = "";
          this.allocationId1 = "";
        })
        .catch()
        .finally();
    },
    //选择分配人
    selectItem3(val) {
      this.selectUser1 = val;
    },
    resetForm3() {
      this.selectUser1 = "";
      this.allocationId1 = "";
      this.dialogFormVisible3 = false;
    },
    resetForm4() {
      this.ruleForm3.name = "";
      this.ruleForm3.status = "";
      this.getUserList1();
    },
    handleChange(val) {
      this.ruleForm3.status = val[val.length - 1];
    },
    // 取回
    stopData(val) {
      this.$confirm("是否取回", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/followup/takeback/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "取回成功",
                type: "success",
              });
              this.followup();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    handleEdit1(val) {
      this.$router.push({
        path: "/complaintAdd",
        query: {
          id: val.id,
        },
      });
    },
    selectMore(val) {
      let path = "";
      if (val == 1) {
        path = "";
        return;
      } else if (val == 2) {
        path = "/default";
      } else if (val == 3) {
        path = "/dispatch";
      } else if (val == 4) {
        path = "/followUp";
      } else {
        path = "/complaint";
      }
      this.$router.push(path);
    },
    handleClick(tab) {
      let index = tab.index;
      this.activeName = tab.name;
      this.numData = [];
      if (index == 0) {
        this.showBaoan = true;
        this.showUser = false;
        this.resetSearch();
        this.getBaoanNum();
      } else if (index == 1) {
        this.showUser = true;
        this.showBaoan = false;
        this.page = 1;
        this.mapSize = 4.8;
        this.cityCode = this.cityList[0].adcode;
        this.selectAddress = this.cityList[0];
        this.showAddress = this.cityList[0].name;
        this.cityCode1 = "";
        this.cityCode2 = "";
        this.articleName = "";
        this.zhengjian = "";
        this.level = "";
        this.articlePhone = "";
        this.numData = [];
        this.getInfo = false;
        this.getUserNum();
      } else {
        this.showBaoan = false;
        this.showUser = false;
        this.getTop();
      }
    },

    getTop() {
      this.$axios
        .post(`/admapi/workbenches/inviterank`)
        .then(({ data }) => {
          this.rankingData = data;
        })
        .catch()
        .finally();
    },
    getUserNum() {
      this.$axios
        .post(`/admapi/workbenches/customjobmap`)
        .then(({ data }) => {
          this.numData = data;
          this.initMap(2);
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.solid {
  width: 1px;
  height: 18px;
  background: #e5e6eb;
  margin: 0 24px;
}

.dis {
  display: flex;
  align-items: center;
}

.disWarp {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.disBetween {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.disAround {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.page_box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-bottom: 34px;
  box-sizing: border-box;
}

.itemBox {
  background: rgba(255, 255, 255, 0.69);
  border-radius: 8px;
  backdrop-filter: blur(2px);
  padding: 17px 24px;
  border: 2px solid #ffffff;
  box-sizing: border-box;
  margin-bottom: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
}

.itemBox1 {
  padding: 0 0 16px 0;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.69);
  border-radius: 8px;
  border: 2px solid #ffffff;
  backdrop-filter: blur(2px);
  margin-bottom: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
}

.bgBox {
  width: 290px;
  height: 143px;
  position: relative;
  margin-top: 7px;
}

.itemBg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.itemBoxTitle {
  margin: 61px 0 0 38px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4e5969;
  line-height: 20px;
}

.num {
  font-size: 36px;
  font-family: Helvetica;
  color: #1d2129;
  line-height: 36px;
  margin: 9px 0 0 38px;
}

.icon {
  width: 24px;
  height: 24px;
  margin-right: 16px;
}

.modelTitle {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #1d2129;
  line-height: 18px;
}

.selectDate {
  width: 248px;
  height: 32px;
  background: #f2f3f5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 0 3px;
  box-sizing: border-box;
}

.dateItem {
  width: 60px;
  height: 26px;
  border-radius: 8px;
  text-align: center;
  font-size: 14px;
  line-height: 26px;
  cursor: pointer;
  font-family: PingFangSC-Regular, PingFang SC;
}

.active {
  background: #fff;
  color: #165dff;
}

.overviewItem {
  width: 290px;
  height: 120px;
  background: #f3f6fc;
  border-radius: 8px;
  padding: 13px 20px;
  box-sizing: border-box;
  margin-top: 16px;
}

.overviewItem:nth-child(2) {
  margin-top: 0;
}

.overviewItem:nth-child(1) {
  margin-top: 0;
}

.overviewTitle {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4e5969;
}

.yesteday {
  padding-right: 8px;
  box-sizing: border-box;
  border-right: #c8deff 1px solid;
  margin-right: 8px;
}

.icon1 {
  width: 12px;
  height: 13px;
}

.rise {
  color: #f53f3f;
  margin: 0 4px 0 8px;
}

.decline {
  color: #00b42a;
  margin: 0 4px 0 8px;
}

.bgColor {
  width: 100%;
  height: 80px;
  background: linear-gradient(265deg, #e5f2ff 0%, #ecfbff 100%);
  border-radius: 8px 8px 0px 0px;
  padding: 26px 24px 36px;
  box-sizing: border-box;
}

.bgColorTitle {
  width: 100%;
  min-height: 70px;
  background: #ffffff;
  border-radius: 16px 16px 8px 8px;
  margin-top: -10px;
  padding: 25px 16px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
}

.more {
  font-size: 14px;
  font-weight: 400;
  color: #4e5969;
  line-height: 22px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.more img {
  width: 12px;
  height: 12px;
  margin-left: 4px;
}

.titleKey {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #86909c;
  line-height: 19px;
}

.titleval {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  line-height: 24px;
}

.titleItem {
  margin-right: 24px;
  flex: none;
}

.indexBtn {
  padding: 0px 10px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #165dff;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #2c68ff;
  line-height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex: none;
}

.indexBtn img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.tableBorder {
  padding: 0 16px;
  box-sizing: border-box;
  overflow: hidden;
}

.tabelRight {
  display: flex;
  justify-content: end;
  align-items: center;
}

.recommendation {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #1d2129;
  line-height: 25px;
  margin-bottom: 16px;
}

.selectItem {
  width: 145px;
  height: 46px;
  background: #fffefe;
  border-radius: 8px 8px 0px 0px;
  text-align: center;
  line-height: 46px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  cursor: pointer;
}

.tabBox {
  width: 100%;
  background: #ffffff;
  border-radius: 0px 8px 8px 8px;
  padding: 22px 16px;
  box-sizing: border-box;
}

.active {
  background: #e8ecfb;
}

.operateBtn {
  padding: 0 10px;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: #2c68ff;
  line-height: 16px;
}

.omit {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.pending {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #cb2634;
  line-height: 14px;
  margin-left: 22px;
}

.select {
  width: 10px;
  height: 10px;
  background: #165dff;
  border-radius: 10px;
}

.bigText {
  font-size: 30px;
  font-weight: 600;
  text-align: center;
  margin-top: 30vh;
}

.noselect {
  width: 10px;
  height: 10px;
  border: #165dff 1px solid;
  border-radius: 10px;
}

.map {
  width: 100%;
  height: 500px;
}

.baoanItem {
  width: 100%;
  border-top: 1px solid #ccc;
  padding: 10px 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.baoanItem img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.peopleNum {
  cursor: pointer;
  display: block;
  width: 100%;
  height: 100%;
}
.peopleNum:hover {
  color: #165dff;
}
</style>
<style>
.el-tabs__header {
  margin: 0 0 !important;
}
.el-table th.el-table__cell {
  background: #f9f9fa !important;
}

.el-popover {
  padding: 0px 16px !important;
  box-sizing: border-box;
  border: none;
  min-width: 0;
}

.el-table tr {
  height: 50px !important;
}
.info-top {
  position: relative;
  /* background: none repeat scroll 0 0 #f9f9f9; */
  /* border-bottom: 1px solid #ccc; */
  border-radius: 5px 5px 0 0;
  text-align: end !important;
}
.info-top {
  display: inline-block;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
  line-height: 31px;
  padding: 0 10px;
}

.info-top {
  position: absolute;
  top: 10px;
  right: 10px;
  transition-duration: 0.25s;
}

.info-top img:hover {
  box-shadow: 0px 0px 5px #000;
}

.info-middle {
  font-size: 12px;
  padding: 10px 20px;
  box-sizing: border-box;
  line-height: 20px;
}

.info-bottom {
  height: 0px;
  width: 100%;
  clear: both;
  text-align: center;
}

.info-bottom img {
  position: relative;
  z-index: 104;
}

/* span {
  margin-left: 5px;
  font-size: 11px;
} */
.info-middle img {
  float: left;
  margin-right: 6px;
}
.content-window-card {
  position: relative;
  box-shadow: none;
  bottom: 0;
  left: 0;
  width: auto;
  padding: 0;
}

.content-window-card p {
  height: 2rem;
}

.custom-info {
  border: solid 1px silver;
}
.custom-content-marker {
  width: 81px;
  height: 36px;
  background-image: url("../../../src/assets/imgs/baoannum.png");
  background-size: 100% 100%;
  text-align: center;
  color: #fff;
  margin-left: -40px;
  margin-top: -40px;
}
.mapSearch {
  width: 100%;
  height: 200px;
  z-index: 99999;
  position: absolute;
  top: 0;
  left: 0;
}
.searchBox {
  background: #fff;
  padding: 10px 0;
  box-sizing: border-box;
  text-align: center;
}
.pusher-container {
  display: none;
}
</style>
